import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=36972910&scoped=true"
import script from "./ItemSelect.vue?vue&type=script&lang=js"
export * from "./ItemSelect.vue?vue&type=script&lang=js"
import style0 from "./ItemSelect.vue?vue&type=style&index=0&id=36972910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36972910",
  null
  
)

export default component.exports